import axios from 'axios';

export default axios.create ({
    //baseURL:'http://localhost:3009'
    baseURL:'https://afa8e48d7138.ngrok.io'
    //baseURL:'https://my-json-server.typicode.com/irfanonk/webRTCdb'
})